import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { testimonials } from '../mock';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const next = () => setI((v) => (v + 1) % testimonials.length);
  const prev = () => setI((v) => (v - 1 + testimonials.length) % testimonials.length);

  return (
    <section id="gallery" className="py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <div className="tag-label justify-center">Voices of Whiteplains</div>
          <h2 className="font-serif-display text-4xl md:text-6xl font-black mt-4 text-[#1c1a17] leading-[1.05]">
            Our brilliant students <span className="italic text-[#b8331f]">speak.</span>
          </h2>
        </motion.div>

        <div className="relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="grid md:grid-cols-5 gap-10 md:gap-14 items-center"
            >
              <div className="md:col-span-2 relative">
                <div className="absolute -inset-4 border border-[#c8942a]/40" />
                <div className="relative aspect-square bg-[#f3ead9] overflow-hidden">
                  <img src={t.img} alt={t.name} className="w-full h-full object-contain" />
                </div>
              </div>
              <div className="md:col-span-3">
                <div className="font-serif-display text-[80px] leading-none text-[#c8942a]">&ldquo;</div>
                <p className="font-cormorant italic text-2xl md:text-3xl leading-[1.4] text-[#1c1a17] font-medium">
                  {t.quote}
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <div className="h-px w-10 bg-[#c8942a]" />
                  <div>
                    <div className="font-serif-display text-xl font-black text-[#1c1a17]">{t.name}</div>
                    <div className="font-sans-pro text-[11px] uppercase tracking-[0.28em] text-[#8f6417] mt-1">{t.role}</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center justify-between mt-14 border-t border-[#eadfc9] pt-6">
            <div className="flex items-center gap-3">
              {testimonials.map((_, idx) => (
                <button key={idx} onClick={() => setI(idx)} className={`h-[2px] transition-all ${idx === i ? 'w-14 bg-[#b8331f]' : 'w-6 bg-[#eadfc9]'}`} aria-label={`slide ${idx + 1}`} />
              ))}
              <span className="font-sans-pro text-[11px] uppercase tracking-[0.3em] text-[#8f6417] ml-3">
                {String(i + 1).padStart(2, '0')} / {String(testimonials.length).padStart(2, '0')}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={prev} className="w-11 h-11 border border-[#eadfc9] grid place-items-center text-[#1c1a17] hover:bg-[#1c1a17] hover:text-white hover:border-[#1c1a17] transition-colors" aria-label="prev">
                <ChevronLeft size={18} />
              </button>
              <button onClick={next} className="w-11 h-11 border border-[#eadfc9] grid place-items-center text-[#1c1a17] hover:bg-[#1c1a17] hover:text-white hover:border-[#1c1a17] transition-colors" aria-label="next">
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
